import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client, CommunicationRecord, EmailMessage } from '../types/aggregate-graph.types';
import { AuditLogEntry } from '../types/patient-audit.types';

export interface EmailClinicalNoteRequest {
	clinicalNoteId: string;
	clinicalNoteVersion: number;
	documentInstanceVersion: number;
	emailMessage: EmailMessage;
	attachmentNameWithoutExtension: string;
}

export interface PatientSignalment {
	birthDate: string | null | undefined;
	species: string;
	breed: string;
	sex: string; // can be empty string
	isNeutered: boolean | null | undefined;
}

export interface SearchedPatient extends PatientSignalment {
	patientId: string;
	caseNumber: string;
	ownerClientId: string;
	firstName: string;
	ownerSurname: string;
	fullName: string;
}

@Injectable({
	providedIn: 'root'
})
export class PatientsService {

	constructor(private httpClient: HttpClient) {
	}

	queryPatients(queryTerm: string, skip: number, take: number) {
		return this.httpClient.get<SearchedPatient[]>(`/api/patients?queryTerm=${queryTerm}&skip=${skip}&take=${take}`);
	}

	setBloodType(id: string, bloodType: string) {
		return this.httpClient.put<void>(`/api/patients/${id}/blood-type`, JSON.stringify(bloodType), { headers: { 'Content-Type': 'application/json' } });
	}

	setProblems(id: string, problems: string) {
		return this.httpClient.put<void>(`/api/patients/${id}/problems`, JSON.stringify(problems), { headers: { 'Content-Type': 'application/json' } });
	}

	setAlerts(id: string, alerts: string) {
		return this.httpClient.put<void>(`/api/patients/${id}/alerts`, JSON.stringify(alerts), { headers: { 'Content-Type': 'application/json' } });
	}
	
	emailClinicalNote(patientId: string, request: EmailClinicalNoteRequest) {
		return this.httpClient.post(`/api/patients/${patientId}/clinical-note-email`, request);
	}

	saveCommunicationRecord(id: string, record: CommunicationRecord) {
		if (record.id)
			return this.httpClient.put<CommunicationRecord>(`/api/patients/${id}/communication-record/${record.id}`, record);
		else
			return this.httpClient.post<CommunicationRecord>(`/api/patients/${id}/communication-record`, record);
	}

	removeCommunicationRecord(id: string, recordId: number) {
		return this.httpClient.delete<void>(`/api/patients/${id}/communication-record/${recordId}`);
	}

	getAuditLog(patientId: string, maxResults: number) {
		return this.httpClient.get<AuditLogEntry[]>(`/api/patients/${patientId}/audit-log?max=${maxResults}`);
	}

	getClients(patientId: string){
		return this.httpClient.get<Client[]>(`/api/patients/${patientId}/clients`);
	}
}